import { FC } from 'react';

import { Tag } from '@rikstv/shared-components';

import { DurationBar } from '../durationBar/DurationBar';
import { AccentPill } from '../pill/Pill';

import { ImageOverlayWrapper } from './ImageOverlayWrapper';
import { programStateFallbackLabel } from './programStateLabel';

import styles from './LiveBroadcastOverlay.module.css';

export const LiveBroadcastOverlay: FC<{
  state: RiksTV.ClientAPI.States['value'];
  progress: number;
  label?: string;
}> = ({ state, progress, label = programStateFallbackLabel.live }) => {
  if (state !== 'Live') {
    return null;
  }

  return (
    <ImageOverlayWrapper className={styles.liveBroadcastOverlay} backdropStyle="gradient">
      <LiveBroadcastPill label={label} />
      <div className={styles.progress}>{progress > 0 && <DurationBar percent={progress} />}</div>
    </ImageOverlayWrapper>
  );
};

export const LiveBroadcastPill = ({ label }: { label: string }) => {
  return (
    <div>
      <AccentPill>
        <Tag className={styles.label}>{label}</Tag>
      </AccentPill>
    </div>
  );
};
